import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("AimPortal crashed", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="aim aim-crash">
          <div className="aim-crash-box">
            <p className="aim-eyebrow">CICLOPE · AIM 2026</p>
            <h1>RED CICLOPE TEMPORALMENTE SIN CONEXIÓN</h1>
            <p>
              El portal encontró un error inesperado. Reintentando en unos
              segundos.
            </p>
            <button onClick={() => location.reload()}>Recargar ahora</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
